<script lang="ts">
    import Tab from "@apps/iloom_customization/components/Tab.svelte";
    import Tabs from "@apps/iloom_customization/components/Tabs.svelte";

    import type TabsManager from "@components/Tabs/TabsManager";

    export let tabsManager: TabsManager;

    const tabs = [
        {
            value: "all",
            name: "全部",
        },
        {
            value: "10坪以下",
            name: "10坪以下",
        },
        {
            value: "10坪",
            name: "10坪",
        },
        {
            value: "20坪",
            name: "20坪",
        },
        {
            value: "30坪",
            name: "30坪",
        },
        {
            value: "40坪",
            name: "40坪",
        },
        {
            value: "50坪以上",
            name: "50坪以上",
        },
    ];
    const openedTab$ = tabsManager.openedTab$;

    const onClick = (value: string) => {
        tabsManager.openTab(value);
    };
</script>

<Tabs class="gw-crv-page__size-tabs">
    {#each tabs as tab}
        <Tab
            class="gw-crv-page__size-tab"
            openedTab={$openedTab$}
            variant="rounded"
            {tab}
            {onClick}
        />
    {/each}
</Tabs>

<style lang="postcss">
    :global(.gw-tabs.gw-crv-page__size-tabs) {
        margin-bottom: 48px;
    }

    @media all and (max-width: 884px) {
        :global(.gw-tabs.gw-crv-page__size-tabs) {
            justify-content: flex-start;
        }
    }

    @media all and (max-width: 600px) {
        :global(.gw-tabs.gw-crv-page__size-tabs) {
            margin-bottom: 18px;
            margin-right: calc(var(--container-gutter, 16px) * -1);
            padding-right: max(
                var(--container-gutter),
                50% - var(--container-max-width) / 2
            );
        }
        :global(.gw-tab.gw-crv-page__size-tab) {
            font-size: 12px;
        }
    }
</style>
